












































  import AbpBase from "@/lib/abpbase";
  import { Component, Prop } from "vue-property-decorator";
  import  { InsertorUpdateThresholdSet,InsertorUpdatePatientThresholdSet} from "@/api/pdOutPatient/pdBasicInformation"
  
  @Component({
    components: { },
  })
  export default class extends AbpBase {
    @Prop() data: any;
    @Prop() value: boolean;
    ThresholdData:any={
        itemCode:'',
        itemName:'',
        minValue:'',
        maxValue:'',
        minWarnContent:'',
        maxWarnContent:''
    };

    created() {
      console.log(this.data);
    if (this.data.mode == "edit") {
        this.ThresholdData =this.data.model;
        console.log(this.ThresholdData);
    }
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  async save() {
    if(this.data.patient==undefined){
    let res = await InsertorUpdateThresholdSet(this.ThresholdData);
    if (res.code == 2000) {
      this.$emit('save-success')}
    //    this.$emit("input", false);
    }else{
    this.ThresholdData.PD_Patient_ID=this.data.patient.pD_Patient_ID;
    let res = await InsertorUpdatePatientThresholdSet(this.ThresholdData);
    if (res.code == 2000) {
      this.$emit('save-success')}
    }
  
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/publicThreshold/addOrEdit.vue